type TextareaSize = "small" | "medium" | "large";

const SIZE_ROWS: Record<TextareaSize, number> = {
  small: 1,
  medium: 3,
  large: 4,
};

const SIZE_MIN_HEIGHT: Record<TextareaSize, string> = {
  small: "min-h-8",
  medium: "min-h-20",
  large: "min-h-28",
};

export { SIZE_ROWS, SIZE_MIN_HEIGHT };
export type { TextareaSize };
